import { AxiosResponse } from "axios";
import { EmailEntryPointService } from "./emailEntryPointService";
import { TypeEnum } from "src/types/textEntryPoints";

export interface ApiEmailEntryPoints {
    getAssignToData(type: TypeEnum): Promise<AxiosResponse>;
    getAllEmailEntryPoints(): Promise<AxiosResponse>;
}

export const emailEntryPointService = new EmailEntryPointService();